import React, { useMemo, type Ref } from 'react';
import { MENU_ID_HELP_CENTER_MANAGEMENT } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { getMenuItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { helpCenterManagementRoute } from '@jira/router-routes__help-center-management-routes/src/helpCenterManagementRoute.tsx';
import { generatePath } from '@atlassian/react-resource-router';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';

export const HelpCenterManagementMenuLinkItem = (
	props: Nav4DragAndDropMenuItemProps,
): React.JSX.Element => {
	const { draggableRef, dropIndicator, hasDragIndicator, isDragging, visualContentRef } = props;

	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(
		MENU_ID_HELP_CENTER_MANAGEMENT,
	);

	const analytics = useMemo(
		() =>
			getMenuItemAnalytics({
				actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_HELP_CENTER_MANAGEMENT],
				itemId: 'helpCenterManagement',
				level: 1,
			}),
		[],
	);

	return (
		<Nav4MenuLinkItem
			analytics={analytics}
			dropIndicator={dropIndicator}
			elemBefore={icon}
			hasDragIndicator={hasDragIndicator}
			href={generatePath(helpCenterManagementRoute.path)}
			isDragging={isDragging}
			menuId={MENU_ID_HELP_CENTER_MANAGEMENT}
			// oxlint-disable-next-line typescript/consistent-type-assertions
			ref={draggableRef as Ref<HTMLAnchorElement> | undefined}
			testId="sidebar-nav4-sidebars-content-help-center-management.sidenav-help-center-management"
			visualContentRef={visualContentRef}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
};
